<template>    
  <UCard class="col-span-10 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-900 dark:border-gray-700">    
    <!-- <template #header>
    </template> -->
    <img v-if="badge.image_png" :src="badge.image_png" :alt="badge.name" class="w-36 float-right ml-5" />
        <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">            
            {{ badge.name }}
            <UBadge class="ml-5 align-middle">{{ badge.tier_name }}</UBadge>
        </h5>
    
        <p class="font-normal text-gray-700 dark:text-gray-400">
        {{ badge.description }}
    </p>

    <template #footer>
      <NuxtLink :to="`/badges/${badge._id}`"
                class="inline-flex items-center px-3 py-2 font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                :alt="`Get Certified in ${badge.name}`">
        Get Certified
        <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                </svg>
      </NuxtLink>
      
    </template>    
  </UCard>  
</template>

<script setup>
const props = defineProps(['badge'])
const tier = ["Novice", "Intermediate", "Advanced"][props.badge.tier - 1];
const badge_id = props.badge.badge_id;
// const badge_url = badge_id 
//                       ? `https://badgr.com/public/badges/${badge_id}` 
//                       : `https://badge.devamplifier.io/${props.badge.tier}/${props.badge.skill_id}`;
</script>

<style scoped>
/* CSS specific to this page */
</style>
